import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ControlMainTabPanel from './controlPanels/ControlMainTabPanel'
import ControlDiagnosticTabPanel from './controlPanels/ControlDiagnosticTabPanel'
import ControlLogTabPanel from './controlPanels/ControlLogTabPanel'
import ControlAtlasPwdLogTabPanel from './controlPanels/ControlAtlasPwdLogTabPanel'

export default function ControlTab(props) {
  console.log("render ControlTab");

  return (
    <div name="divControlTab">
      <Routes>
        <Route path="/main" element={<ControlMainTabPanel/>}/>
        <Route path="/diagnostic" element={<ControlDiagnosticTabPanel/>} />  
        <Route path="/log" element={<ControlLogTabPanel/>}/>
        <Route path="/atlasPwdLog" element={<ControlAtlasPwdLogTabPanel/>}/>
    </Routes>
  </div>
  );
}